import React, { useState, useEffect } from 'react';
import API from '../../api/axios';
import './Admin.css';

export default function AdminUsersPage() {
    const [users, setUsers] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);

    const load = () => {
        setLoading(true);
        API.get(`/api/admin/users?search=${search}`)
            .then(res => setUsers(res.data.users || []))
            .finally(() => setLoading(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { load(); }, []);

    const handleBan = async (userID) => {
        const reason = window.prompt('Ban reason:');
        if (!reason) return;
        await API.put(`/api/admin/users/${userID}/ban`, { reason });
        load();
    };

    const handleUnban = async (userID) => {
        if (!window.confirm('Unban this user?')) return;
        await API.put(`/api/admin/users/${userID}/unban`);
        load();
    };

    return (
        <div className="admin-page">
            <header className="admin-header">
                <h1>User Management</h1>
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Search by email or name..."
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && load()}
                    />
                    <button onClick={load}>Search</button>
                </div>
            </header>

            {loading ? <div className="admin-loading">Loading...</div> : (
                <div className="users-list">
                    {users.length === 0 && <p className="empty">No users found.</p>}
                    {users.map(user => (
                        <div key={user.id} className={`user-card ${user.is_banned ? 'banned' : ''}`}>
                            <div className="user-info">
                                <strong>{user.full_name || '—'}</strong>
                                <span>{user.email}</span>
                                <div className="user-badges">
                                    <span className={`badge role-${user.role}`}>{user.role}</span>
                                    {user.subscription_tier && (
                                        <span className="badge premium">{user.subscription_tier}</span>
                                    )}
                                    {user.is_banned && <span className="badge banned">Banned</span>}
                                    {!user.is_verified && <span className="badge unverified">Unverified</span>}
                                </div>
                                {user.ban_reason && <p className="ban-reason">Reason: {user.ban_reason}</p>}
                            </div>
                            <div className="user-actions">
                                {user.is_banned ? (
                                    <button className="btn-unban" onClick={() => handleUnban(user.id)}>
                                        Unban
                                    </button>
                                ) : (
                                    <button className="btn-ban" onClick={() => handleBan(user.id)}>
                                        Ban
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}